import { useMutation, useQuery } from "react-query";
import guidelinesApi from "../apis/guidelines";
import orderBatchesApi from "../apis/orderBatches";
const { fetchGetAllMarketPlace } = guidelinesApi;
const {
  addNewMarketplaceForUser,
  createNewBatch,
  fetchAllBatches,
  listAddOnServices,
  attachMarketPlaces,
  getBatchSkuList,
  deleteFolder,
  attachAddOnServices,
  getBatchSummary,
  addActionToAddOnInDraftSku,
  completeOrderCreation,
  removeAddOnServiceFromAnSku,
  upsertAddOnServiceToSku,
  getListAddOns,
  getCsvData,
  attachCsvToBatch,
  deleteDraftSkuForUser,
  getBillingInformation,
  updateBillingInformation,
  getPaymentInfo,
  initiateCheckoutForBatch,
  batchQuoteInfo,
  getBatchOverview,
  getBatchCSV,
} = orderBatchesApi;

export const useGetAllMarketPlace = (
  remark,
  orgId,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, orgId, pageNum, pageSize],
    () => fetchGetAllMarketPlace(orgId, pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useCreateNewBatch = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewBatch(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetBatchCSV = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return getBatchCSV(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetAllBatches = (
  remark,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => fetchAllBatches(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useAddNewMarketPlaceForUser = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return addNewMarketplaceForUser(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useListAddOnServices = (
  remark,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => listAddOnServices(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useAttachMarketPlaces = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return attachMarketPlaces(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useGetBatchSkuList = (remark, batchId, onSuccess, onError) =>
  useQuery(["" + remark, batchId], () => getBatchSkuList(batchId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useDeleteFolder = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return deleteFolder(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useAttachAddOnServices = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return attachAddOnServices(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useGetBatchSummary = (remark, batchId, onSuccess, onError) =>
  useQuery(["" + remark, batchId], () => getBatchSummary(batchId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useAddActionToAddOnInDraftSku = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return addActionToAddOnInDraftSku(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useCompleteOrderCreation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: ({ batchId, payload }) => {
      return completeOrderCreation(batchId, payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useRemoveAddOnServiceFromAnSku = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return removeAddOnServiceFromAnSku(payload);
    },
    onSuccess,
    onError,
  });
};
export const useDeleteDraftSkuForUser = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return deleteDraftSkuForUser(payload);
    },
    onSuccess,
    onError,
  });
};
export const useUpsertAddOnServiceToSku = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return upsertAddOnServiceToSku(payload);
    },
    onSuccess,
    onError,
  });
};

export const useGetListAddOns = (remark, draftSku, onSuccess, onError) =>
  useQuery(["" + remark, draftSku], () => getListAddOns(draftSku), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });

export const useGetCsvData = (remark, payload, onSuccess, onError) =>
  useQuery(["" + remark, payload], () => getCsvData(payload), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useAttachCsvToBatch = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return attachCsvToBatch(payload);
    },
    onSuccess,
    onError,
  });
};
export const useUpdateBillingInformation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return updateBillingInformation(payload);
    },
    onSuccess,
    onError,
  });
};

export const useGetBillingInformation = (onSuccess, onError) =>
  useQuery(["billingInformation"], () => getBillingInformation(), {
    onSuccess,
    onError,
  });
export const useGetPaymentInfo = (remark, id, onSuccess, onError) =>
  useQuery(["paymentInfo" + remark, id], () => getPaymentInfo(id), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useInitiateCheckoutForBatch = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return initiateCheckoutForBatch(payload);
    },
    onSuccess,
    onError,
  });
};
export const useBatchQuoteInfo = (remark, batchId, onSuccess, onError) =>
  useQuery(["batchInfo" + remark, batchId], () => batchQuoteInfo(batchId), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
export const useGetBatchOverview = (remark, onSuccess, onError) =>
  useQuery(["batchOverview" + remark], () => getBatchOverview(), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
